export const NOTIFICATIONS_STATE = 'info-data'
